import { render, staticRenderFns } from "./OrderListAdmin.vue?vue&type=template&id=7aa70669&scoped=true"
import script from "./OrderListAdmin.vue?vue&type=script&lang=js"
export * from "./OrderListAdmin.vue?vue&type=script&lang=js"
import style0 from "./OrderListAdmin.vue?vue&type=style&index=0&id=7aa70669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa70669",
  null
  
)

export default component.exports